import { logger } from '@/features/print/logger'
import { useAppDispatch } from '@/hooks/redux'
import { loadPrinters } from '@/redux/reducers/printers'
import { useEffect } from 'react'

export const useLoadPrinters = () => {
    const dispatch = useAppDispatch()

    useEffect(() => {
        const handleLoadPrinters = async () => {
            try {
                await dispatch(loadPrinters()).unwrap()
            } catch (e) {
                logger.errorOnly(e)
            }
        }

        handleLoadPrinters()
    }, [dispatch])
}
